module.exports = __webpack_public_path__ + "img/type1_bg2.f84613d7.png";